export class MissingDataError extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'MissingDataError'
    }
}

export class NotLoggedInError extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'NotLoggedInError'
    }
}

export class InvalidMnemonicError extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'InvalidMnemonicError'
    }
}

export class IncompatibleWalletError extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'IncompatibleWalletError'
    }
}